import { render, staticRenderFns } from "./addClassroom.vue?vue&type=template&id=f41c4992&scoped=true&"
import script from "./addClassroom.vue?vue&type=script&lang=js&"
export * from "./addClassroom.vue?vue&type=script&lang=js&"
import style0 from "./addClassroom.vue?vue&type=style&index=0&id=f41c4992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41c4992",
  null
  
)

export default component.exports